export const SET_RATING = 'SET_RATING';



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/constants/ratings.ts